import gql from 'graphql-tag';

export const UPDATE_REPORTING_TEAMS_RESILIENCE_ANCHORS_FILTER = gql`
  mutation updateReportingTeamsResilienceAnchorsFilter($filter: ReportingTeamsResilienceAnchorsFilterInput!) {
    updateReportingTeamsResilienceAnchorsFilter(filter: $filter) @client
  }
`;
